import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontCreteRound, fontRobotoCondensed, theme } from "shared/lib/styles";

import { ContentItemCommentV2 } from "scmp-app/components/content/content-item-render/variants/comment-v2";
import { ContentItemHarry } from "scmp-app/components/content/content-item-render/variants/harry";
import {
  CoverImage as HarryCoverImage,
  StyledEntityLink as HarryEntityLink,
  Headline as HarryHeadline,
} from "scmp-app/components/content/content-item-render/variants/harry/styles";

import IconArrow from "./icon-arrow.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;

  border-block-start: 4px #000000 solid;

  padding-block-start: 12px;
`;

export const Title = styled(BaseLink)`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const ItemContainer = styled.div`
  display: grid;
  grid:
    "item-1" min-content
    "item-2" min-content
    "item-3" min-content
    "item-4" min-content
    "item-5" min-content
    "item-6" min-content
    "item-harry" min-content
    / 100%;
  row-gap: 16px;

  ${theme.breakpoints.only("tablet")} {
    grid:
      "item-1 divider item-5" min-content
      "item-2 divider item-6" min-content
      "item-3 divider item-harry" min-content
      "item-4 divider item-harry" min-content
      ". divider item-harry" min-content
      / 1fr 1px 1fr;
    column-gap: 20px;
  }
`;

export const Divider = styled.div`
  grid-area: divider;

  inline-size: 0;
  block-size: 100%;
  border-inline-start: 1px #dfdfdf solid;

  ${theme.breakpoints.not("tablet")} {
    display: none;
  }
`;

const StyledContentItemCommentV2 = styled(ContentItemCommentV2)`
  :not(:first-of-type) {
    border-block-start: 1px #dfdfdf solid;

    padding-block-start: 16px;
  }
`;

export const Item1 = styled(StyledContentItemCommentV2)`
  grid-area: item-1;
`;

export const Item2 = styled(StyledContentItemCommentV2)`
  grid-area: item-2;
`;

export const Item3 = styled(StyledContentItemCommentV2)`
  grid-area: item-3;
`;

export const Item4 = styled(StyledContentItemCommentV2)`
  grid-area: item-4;
`;

export const Item5 = styled(StyledContentItemCommentV2)`
  grid-area: item-5;

  ${theme.breakpoints.only("tablet")} {
    border-block-start: none !important;

    padding-block-start: 0 !important;
  }
`;

export const Item6 = styled(StyledContentItemCommentV2)`
  grid-area: item-6;
`;

export const ItemHarry = styled(ContentItemHarry)`
  grid-area: item-harry;

  border-block-start: 1px #dfdfdf solid;

  padding-block-start: 16px;

  ${HarryEntityLink} {
    margin-block-end: 8px;

    font-weight: 400;
    font-size: 17px;
    font-family: ${fontCreteRound};
    line-height: 1.3;
  }
  ${HarryHeadline} {
    color: #2aa191;
  }
  ${HarryCoverImage} {
    aspect-ratio: auto;

    img {
      inline-size: 100%;
      block-size: auto;
    }
  }
`;

export const MoreLinkContainer = styled.div`
  border-block-start: 1px solid #dfdfdf;

  padding-block-start: 16px;
`;

export const MoreLink = styled(BaseLink)`
  display: inline-flex;
  gap: 8px;
  align-items: center;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
`;

export const Arrow = styled(IconArrow)`
  flex-shrink: 0;
`;
